import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';
import { OrgService } from './modules/org-sys-area/services/org.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OrganisationFilterService } from './layout/common/organisation-filter/organisation-filter.service';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const orgService = inject(OrgService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([navigationService.get(), orgService.getSimpleOrganisationsForUsers()]);
};

export const orgResolver = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    let orgId = route.params['orgId'];
    const localOrgId = localStorage.getItem('organisation');

    if (!orgId && localOrgId) {
        orgId = localOrgId;
    }

    localStorage.setItem('organisation', orgId);
    inject(OrganisationFilterService).selectedOrganisation = orgId;
};
